import { useScrollTrigger } from '@material-ui/core'
import * as React from 'react'

interface Props {
    window?: Node | Window | undefined

}

export const HandleScrollLink : React.FC<Props> = ({ window, children }) => {
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ?? window
    })

    // @ts-ignore
    return React.cloneElement(children, {
        style: {
            backgroundColor: trigger ? 'white' : 'transparent',
            fontWeight: 300,
            borderRadius: 5,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: trigger ? '#33949E' : 'white',
            color: trigger ? '#33949E' : 'white',
            transition: trigger ? '0.3s' : '0.5s',
            boxShadow: trigger ? 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px' : 'none',
            padding: '5px 8px',
            margin: '0px 5px',
            minWidth: 90,
            textAlign: 'center',
            cursor: 'pointer',
            '&:hover, &:focus': {
                borderColor: '#33949E',
                color: '#33949E',
            },

        }
    })
}

HandleScrollLink.defaultProps = {
    window: undefined
}

export const ScrollLink: React.FC<Props> = (props) => {

    return (
        <div>
            <HandleScrollLink {...props}>{props.children}</HandleScrollLink>
        </div>

    )
}
